import { useEffect, useState, useCallback } from "react";
import api, { apiErr } from "@/lib/api";
import { datetime } from "@/lib/format";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { RotateCcw, Trash2 } from "lucide-react";

export default function RestoreBin() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/bin").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const restore = async (b) => {
    try { await api.post(`/admin/bin/${b.id}/restore`); toast.success(`Restored ${b.label}`); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const purge = async (b) => {
    if (!window.confirm(`Delete ${b.label} forever? This cannot be undone.`)) return;
    await api.delete(`/admin/bin/${b.id}`); toast.success("Deleted forever"); load();
  };
  const empty = async () => {
    if (!window.confirm(`Permanently delete all ${rows.length} item(s) in the bin?`)) return;
    await api.delete("/admin/bin"); toast.success("Bin emptied"); load();
  };
  return (
    <div className="mt-4">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="text-sm text-muted-foreground">Deleted items stay here for 30 days, then are removed permanently.</p>
        {rows.length > 0 && <Button variant="outline" onClick={empty} data-testid="bin-empty" className="text-red-400"><Trash2 className="w-4 h-4 mr-1" />Empty bin</Button>}
      </div>
      {rows.length === 0 ? <div className="card-industrial p-8 text-center text-sm text-muted-foreground" data-testid="bin-empty-state">The Restore Bin is empty.</div> : (
        <div className="card-industrial divide-y divide-border" data-testid="bin-list">
          {rows.map((b) => (
            <div key={b.id} className="px-4 py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`bin-row-${b.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2"><span className="text-[10px] px-2 py-0.5 rounded bg-accent font-mono uppercase">{b.entity.replace(/_/g, " ")}</span><span className="font-semibold">{b.label}</span></div>
                <div className="text-xs text-muted-foreground mt-1">
                  Deleted by {b.deleted_by} · {datetime(b.deleted_at)}{b.count > 1 ? ` · ${b.count} linked records` : ""} ·{" "}
                  <span className={b.days_left <= 5 ? "text-amber-400 font-bold" : ""} data-testid={`bin-days-${b.id}`}>{b.days_left} days left</span>
                </div>
              </div>
              <div className="flex gap-2">
                <Button size="sm" onClick={() => restore(b)} data-testid={`bin-restore-${b.id}`}><RotateCcw className="w-4 h-4 mr-1" />Restore</Button>
                <Button size="sm" variant="outline" onClick={() => purge(b)} data-testid={`bin-purge-${b.id}`} className="text-red-400"><Trash2 className="w-4 h-4 mr-1" />Delete forever</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
